import React from 'react';
import { useInView } from 'react-intersection-observer';

import { ReactComponent as Arrow } from '../../images/icons/fs-lc-arrow.svg';
import { getThemeClass } from '../../tools/textTools';
import PageSection from '../PageSections/PageSection';
import * as styles from './ComparisonTable.module.scss';
import RichTextConverter from './RichText/RichTextConverter';
import SmartLink from './SmartLink';

const ComparisonTable = ({ section }) => {
  const { ref: containerRef, inView: isVisible } = useInView({
    threshold: 0.25,
    triggerOnce: true,
  });

  const themeClass = getThemeClass(section.colorTheme?.themeName);

  return (
    <PageSection data-analytics-section={'comparison-table'} className={[styles.section, themeClass].join(' ')}>
      {section.heading && (
        <div className={styles.heading} ref={containerRef}>
          <h2>{section.heading}</h2>
          {section.sectionCopy && <RichTextConverter className={styles.subhead} copy={section.sectionCopy} />}
        </div>
      )}
      <div className={styles.table} ref={containerRef}>
        {section.content.map((column, i) => (
          <div
            key={i}
            className={[
              styles.column,
              isVisible ? styles.visible : styles.hidden,
              styles[column.accentColor?.toLowerCase()],
            ].join(' ')}
          >
            <h4>{column.heading}</h4>
            <ul>
              {column.content.map((row, i) =>
                row.linkLabel && row.linkUrl ? (
                  <li
                    className={styles.hasLink}
                    data-analytics-component={'table-item'}
                    data-analytics-id={row.title}
                    key={i}
                  >
                    {row.image && <img src={row.image.file?.url} alt={row.image.title || row.title} />}
                    {row.title}{' '}
                    <SmartLink to={row.linkUrl}>
                      {row.linkLabel}
                      <Arrow className={styles.arrow} />
                    </SmartLink>
                  </li>
                ) : (
                  <li data-analytics-component={'table-item'} data-analytics-id={row.title} key={i}>
                    {row.image && <img src={row.image.file?.url} alt={row.image.title || row.title} />}
                    {row.title}
                  </li>
                )
              )}
            </ul>
          </div>
        ))}
      </div>
    </PageSection>
  );
};

export default ComparisonTable;
